import { LineMeta, LineTypes } from './models';
import { monthToShortMonth } from '@sunbit-dev/common/helpers/dates';

export const convert = (object: {}[], meta: LineMeta) => {
  if (!object) return { keys: [], series: [] };
  const keys = object.map((item: any) =>
    meta.type === LineTypes.YoY ? monthToShortMonth(item[meta.xAxis]) : item[meta.xAxis]
  );
  return {
    keys,
    series: meta.legends.map((legend: string) => ({
      name: legend,
      data: object.map((item: any) => item[meta.yAxis[legend]]),
    })),
  };
};
